module.exports = __webpack_public_path__ + "img/mockup.15dd3ba9.png";